// extracted by mini-css-extract-plugin
export var notfound__title = "_404-module--notfound__title--7v5wu";
export var fadeOutAnimation = "_404-module--fadeOutAnimation--2f8jS";
export var fadeInAnimation = "_404-module--fadeInAnimation--4QUAw";